import React from 'react';

const Share = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle cx="6" cy="12" r="2.5" stroke="black" />
    <circle cx="17.5" cy="6" r="2.5" stroke="black" />
    <circle cx="17.5" cy="18" r="2.5" stroke="black" />
    <path d="M8.25 10.75L15.25 7.25" stroke="black" strokeLinecap="round" />
    <path d="M8.25 13.25L15.25 16.75" stroke="black" strokeLinecap="round" />
  </svg>
);

export default Share;
